<template>
  <img 
    class="matchy-logo" 
    :class="[position, size]" 
    :style="customStyles" 
    src="/logo-horizontal.png" 
    alt="logo" 
  />
</template>

<script>
export default {
  name: 'MatchyLogo',
  props: {
    position: {
      type: String,
      default: 'top-right'  // Default position
    },
    size: {
      type: String,
      default: 'small'  // Default size
    },
    customStyles: {
      type: Object,
      default: () => ({})  // Custom inline styles
    }
  }
}
</script>

<style>
.matchy-logo {
  position: absolute;
}

.top-right {
  top: 5px;
  right: 5px;
  height: 20px;
}

.bottom-right {
  bottom: 160px;
  right: 5px;
  height: 20px;
}

.center {
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  height: 70px;
}

/* Size Variants */
.small {
  height: 20px;
}

.medium {
  height: 50px;
}

.large {
  height: 70px;
}
</style>
